import { ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ProductModel } from './product.model';
import { ProductService } from './product.service';

@Injectable({
  providedIn: 'root',
})
export class ProductResolver {
  constructor(private service: ProductService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<ProductModel> {
    return this.service.getById(route.paramMap.get('id') || '').pipe(map((product) => product.data));
  }
}
